/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_SubmitInputs */

const en_feedback_submit = /** @type {(inputs: Feedback_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send Feedback`)
};

const de_feedback_submit = /** @type {(inputs: Feedback_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feedback senden`)
};

const fr_feedback_submit = /** @type {(inputs: Feedback_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envoyer`)
};

const es_feedback_submit = /** @type {(inputs: Feedback_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar comentarios`)
};

const it_feedback_submit = /** @type {(inputs: Feedback_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invia feedback`)
};

const nl_feedback_submit = /** @type {(inputs: Feedback_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feedback verzenden`)
};

const pl_feedback_submit = /** @type {(inputs: Feedback_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyślij opinię`)
};

const fi_feedback_submit = /** @type {(inputs: Feedback_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lähetä palautetta`)
};

const da_feedback_submit = /** @type {(inputs: Feedback_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send feedback`)
};

const sv_feedback_submit = /** @type {(inputs: Feedback_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skicka feedback`)
};

/**
* | output |
* | --- |
* | "Send Feedback" |
*
* @param {Feedback_SubmitInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const feedback_submit = /** @type {((inputs?: Feedback_SubmitInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_SubmitInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_feedback_submit(inputs)
	if (locale === "fr") return fr_feedback_submit(inputs)
	if (locale === "es") return es_feedback_submit(inputs)
	if (locale === "it") return it_feedback_submit(inputs)
	if (locale === "nl") return nl_feedback_submit(inputs)
	if (locale === "pl") return pl_feedback_submit(inputs)
	if (locale === "fi") return fi_feedback_submit(inputs)
	if (locale === "da") return da_feedback_submit(inputs)
	if (locale === "sv") return sv_feedback_submit(inputs)
	return en_feedback_submit(inputs)
});